import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'

const { ENVIROMENT } = CONFIG

const PatrimoniosHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async fetchSaldoPatrimonial(tpsIds) {
    try {
      const url = this.baseURL + `/saldo-patrimonial?tp_ids=${tpsIds.join(',')}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async fetchPendenciasPorTransportadora(tpsIds) {
    try {
      const url = this.baseURL + `/pendencias-por-transportadora?tps_ids=${tpsIds.join(',')}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default PatrimoniosHttp
